import React from "react";

export default function PromoFooter() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Background */}
      <img
        src="/biznep-mainsite/promobg.webp"
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Subtle overlay */}
      <div className="absolute inset-0 bg-[#174b86]/10" />

      {/* ================= DESKTOP ================= */}
      <div className="relative hidden h-[150px] w-full lg:block">
        <div className="relative flex h-full w-full items-center px-[30px]">

          {/* TEXT */}
          <div className="shrink-0">
            <h2 className="text-[28px] font-extrabold leading-none tracking-[-0.5px] text-white">
              Support Local. Build Stronger.
            </h2>

            <p className="mt-[10px] text-[15px] leading-[1.4] text-white">
              Small businesses make a big difference.
              <br />
              Let's grow together.
            </p>
          </div>

          {/* RIGHT CONTENT GROUP */}
          <div className="ml-auto flex h-full items-center">

            {/* APP STORE */}
            <button
              type="button"
              className="
                flex
                h-[52px]
                w-[145px]
                shrink-0
                items-center
                rounded-[7px]
                bg-black
                px-[10px]
              "
            >
              <img
                src="/biznep-mainsite/ios.webp"
                alt=""
                className="h-[29px] w-[29px] shrink-0 object-contain"
              />

              <div className="ml-[7px] text-left leading-none text-white">
                <div className="text-[7px]">
                  Download on the
                </div>

                <div className="mt-[4px] text-[15px] font-semibold">
                  App Store
                </div>
              </div>
            </button>

            {/* GAP */}
            <div className="w-[14px] shrink-0" />

            {/* GOOGLE PLAY */}
            <button
              type="button"
              className="
                flex
                h-[52px]
                w-[145px]
                shrink-0
                items-center
                rounded-[7px]
                bg-black
                px-[10px]
              "
            >
              <img
                src="/biznep-mainsite/playstore.webp"
                alt=""
                className="h-[29px] w-[29px] shrink-0 object-contain"
              />

              <div className="ml-[7px] text-left leading-none text-white">
                <div className="text-[7px]">
                  GET IT ON
                </div>

                <div className="mt-[4px] text-[15px] font-semibold">
                  Google Play
                </div>
              </div>
            </button>

            {/* GAP BEFORE PHONE */}
            <div className="w-[25px] shrink-0" />

            {/* PHONE */}
            <img
              src="/biznep-mainsite/promophone.webp"
              alt="BizNep mobile app"
              className="
                h-[150px]
                w-auto
                shrink-0
                self-end
                object-contain
              "
            />

          </div>
        </div>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="relative flex min-h-[280px] flex-col items-center px-5 py-8 text-center lg:hidden">

        {/* TEXT */}
        <h2 className="text-[22px] font-extrabold leading-tight text-white">
          Support Local. Build Stronger.
        </h2>

        <p className="mt-3 text-[13px] leading-[1.45] text-white">
          Small businesses make a big difference.
          <br />
          Let's grow together.
        </p>

        {/* STORE BUTTONS */}
        <div className="mt-5 flex items-center gap-2">

          {/* APP STORE */}
          <button
            type="button"
            className="
              flex
              h-[40px]
              w-[115px]
              items-center
              rounded-[6px]
              bg-black
              px-[8px]
            "
          >
            <img
              src="/biznep-mainsite/ios.webp"
              alt=""
              className="h-[22px] w-[22px] object-contain"
            />

            <div className="ml-[5px] text-left leading-none text-white">
              <div className="text-[6px]">
                Download on the
              </div>

              <div className="mt-[2px] text-[12px] font-semibold">
                App Store
              </div>
            </div>
          </button>

          {/* GOOGLE PLAY */}
          <button
            type="button"
            className="
              flex
              h-[40px]
              w-[115px]
              items-center
              rounded-[6px]
              bg-black
              px-[8px]
            "
          >
            <img
              src="/biznep-mainsite/playstore.webp"
              alt=""
              className="h-[22px] w-[22px] object-contain"
            />

            <div className="ml-[5px] text-left leading-none text-white">
              <div className="text-[6px]">
                GET IT ON
              </div>

              <div className="mt-[2px] text-[12px] font-semibold">
                Google Play
              </div>
            </div>
          </button>
        </div>

        {/* PHONE */}
        <img
          src="/biznep-mainsite/promophone.webp"
          alt="BizNep mobile app"
          className="mt-5 h-[145px] w-auto object-contain"
        />
      </div>
    </section>
  );
}